const INDEX_ITEMS = [
  { label: '韩漫热榜', icon: 'ri-fire-line', desc: '最热韩漫一网打尽' },
  { label: '日漫精选', icon: 'ri-sun-line', desc: '经典与治愈并存' },
  { label: '国漫专区', icon: 'ri-china-railway-line', desc: '国风佳作云集' },
  { label: '恋爱专题', icon: 'ri-heart-line', desc: '甜蜜爱情故事集' },
  { label: '悬疑推理', icon: 'ri-search-eye-line', desc: '烧脑案件解谜' },
  { label: '古风玄幻', icon: 'ri-moon-line', desc: '仙侠世界传奇' },
  { label: '校园日常', icon: 'ri-school-line', desc: '青春校园物语' },
  { label: '新番连载', icon: 'ri-rocket-line', desc: '首发新作速递' },
];

export default function Index() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            漫画索引
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            按分类快速找到你想看的漫画类型，总有一款适合你
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {INDEX_ITEMS.map((item, i) => (
            <a
              key={i}
              href="#cards"
              className="group flex items-center gap-4 p-4 md:p-5 bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${item.icon} text-lg`} />
              </div>
              <div className="min-w-0">
                <div className="text-sm font-semibold text-foreground-900 font-heading group-hover:text-primary-600 transition-colors">
                  {item.label}
                </div>
                <div className="text-xs text-foreground-500 mt-0.5">{item.desc}</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}